/**
 * Setup controls that only show once matching-server's `start()` reads them.
 *
 * While a control is off here, the setup flow hides it, and
 * `fitConfigToSession` pins its value, so an older saved config can't carry
 * a setting the server would silently ignore. Set a flag to true when the
 * server supports that control.
 */
export const SERVER_SUPPORTS: {
  /** `enforce.availability`: the "Enforce participant availability" switch. Pinned on. */
  availabilitySwitch: boolean;
  /** `types.max`: "Most" under "Number of types in each group". Pinned to no limit. */
  typesMax: boolean;
} = {
  availabilitySwitch: false,
  typesMax: false,
};
